<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter
            :headers="filter_headers"
            :viewName="viewName"
            v-on:applyFilter="applyFilter"
            v-on:quickFilter="quickFilter"
          ></hpo-filter>
          <div class="pl-2" v-if="selectedItems.length > 0"><a href="#" @click="dialogUpdate = true">Cập nhật trạng thái cảnh báo</a></div>
          <v-layout row wrap>
            <v-btn style="margin:0 10px 10px 12px;" @click="selectedStatus = 1; filter_data(true);" :color="selectedStatus == 1 ? '#a77800' : '#646262'" dark>
              Đang đến kho gửi
            </v-btn>
            <v-btn style="margin-right: 10px;" @click="selectedStatus = 2; filter_data(true);" :color="selectedStatus == 2 ? '#a77800' : '#646262'" dark>
              Đã nhập kho gửi
            </v-btn>
            <v-btn style="margin-right: 10px;" @click="selectedStatus = -1; filter_data(true);" :color="selectedStatus == -1 ? '#a77800' : '#646262'" dark>
              Tất cả
            </v-btn>
          </v-layout>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
            show-select v-model="selectedItems" item-key="ID"
          >
          <template v-slot:item="{ item, isSelected, select}">
            <tr :active="isSelected">
                <td @click="select(!isSelected)"><v-checkbox primary hide-details :input-value="isSelected"></v-checkbox></td>
                <td>{{ item.TransactionCode }}</td>
                <td>{{ item.VbiCode }}</td>
                <td>{{ item.OrderID > 0 ? (item.PackageType == 0 ? 'MD' : 'KG') + item.OrderID : ''}}</td>
                <td>{{ item.OrderCreatedDate | display_date }}</td>
                <td>
                  {{ item.IsFragileGoods ? 'Đóng gỗ' : '' }}
                  <br v-if="item.IsFragileGoods" />
                  {{ item.IsCheck ? 'Kiểm hàng' : '' }}
                  <br v-if="item.IsCheck" />
                  {{ item.OrderGuarantee ? 'Bảo hiểm' : '' }}
                </td>
                <td>
                  {{item.PackageCode}}
                </td>
                <td>{{ item.ChinaStoreID | display_value(chinaStores, 'ID', 'Name') }}</td>
                <td>{{ item.StoreCNImportDate | display_date }}</td>
                <td>{{ item.PackDate | display_date }}</td>
                <td>{{ item.Username }}</td>
                <td>
                  <v-edit-dialog
                    :return-value.sync="item.WarningStatus"
                    large
                    lazy
                    persistent
                    @save="saveItem({'ID': item.ID, 'WarningStatus': item.WarningStatus})"
                  >
                    <div v-bind:style="{ 'color': get_status_color(item.WarningStatus, warning_status)}">{{ item.WarningStatus | display_value(warning_status) }}</div>
                    <template v-slot:input>
                      <v-select
                        :items="warning_status"
                        v-model="item.WarningStatus"
                        item-text="name"
                        item-value="value"
                      ></v-select>
                    </template>
                  </v-edit-dialog>
                </td>
                <td class="truncate">
                  <v-edit-dialog :return-value.sync="item.StoreCNNote" large lazy persistent @save="saveItem({'ID': item.ID, 'StoreCNNote': item.StoreCNNote})">
                      <v-tooltip top right max-width="250">
                          <template v-slot:activator="{ on }">
                              <span v-on="on">{{ item.StoreCNNote }}</span>
                          </template>
                          <span>{{ item.StoreCNNote }}</span>
                      </v-tooltip>
                      <template v-slot:input>
                          <v-textarea v-model="item.StoreCNNote" label="Ghi chú" single-line autofocus></v-textarea>
                      </template>
                  </v-edit-dialog>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <store-popup
        :dialogStoreManager="dialogStoreManager"
        v-on:closePopup="closePopup"
        @deleteItem="deleteItem"
      ></store-popup>
      <v-dialog v-model="dialogUpdate" max-width="300px">
        <v-card>
            <v-card-title>
                <span class="title">Cập nhật mã vận đơn</span>
            </v-card-title>
            <v-card-text>
                <v-container grid-list-md pa-0>
                    <v-layout row wrap>
                        <v-flex lg12>
                            <v-select
                            v-model="selectedWarningStatus"
                            label="Trạng thái cảnh báo"
                            :items="warning_status" item-text="name" item-value="value" item-disabled="locked"
                            ></v-select>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1 white--text" @click="dialogUpdate = false">Đóng</v-btn>
                <v-btn color="red darken-1 white--text" @click="updateBatch">OK</v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import store from "@/components/popups/store";
import { sendErrorNotice } from "@/commons/utils";
import _ from "lodash";

export default {
  components: {
    "hpo-filter": Filtering,
    "store-popup": store
  },
  data() {
    let dataType = configs.DATA_TYPE;
    return {
      headers: [
        {
          text: "Mã vận đơn",
          value: "TransactionCode",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
        {
          text: "Mã VBI",
          value: "VbiCode",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
        {
          text: "Mã đơn hàng",
          value: "OrderID",
          filterable: true,
          quickSearch: true,
          dataType: dataType["Number"]
        },
        {
          text: "Ngày tạo đơn",
          value: "OrderCreatedDate",
          filterable: true,
          quickSearch: true,
          dataType: dataType["Date"]
        },
        {
          text: "Cảnh báo",
          sortable: false,
          filterable: false,
        },
        {
          text: "Mã bao hàng",
          value: "PackageCode",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
        {
            text: "Kho gửi",
            value: "ChinaStoreID",
            filterable: true,
            values: [],
            dataType: configs.DATA_TYPE["Enum"]
        },
        {
          text: "Ngày nhập kho",
          value: "StoreCNImportDate",
          filterable: true,
          dataType: dataType["Date"]
        },
        {
          text: "Ngày đóng bao",
          value: "PackDate",
          filterable: true,
          dataType: dataType["Date"]
        },
        {
          text: "Khách hàng",
          value: "Username",
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Trạng thái cảnh báo",
          value: "WarningStatus",
          filterable: true,
          values: configs.WARNING_STATUS,
          dataType: dataType["Enum"]
        },
        {
          text: "Ghi chú",
          value: "StoreCNNote",
          filterable: true,
          dataType: dataType["String"]
        }
      ],
      pagination: { ...configs.PAGINATION, sortBy: ["ID"]},
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "packagewarning_list",
      filterConditions: [],
      quickFilterConditions: [],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      dialogStoreManager: false,
      dialogEditTranCode: false,
      package_status: configs.PACKAGE_STATUS,
      package_status_enum: configs.PACKAGE_STATUS_ENUM,
      selectedStatus: configs.PACKAGE_STATUS_ENUM.DANG_TOI_KHO_GUI,
      warning_status: configs.WARNING_STATUS,
      warning_status_enum: configs.WARNING_STATUS_ENUM,
      dialogUpdate: false,
      selectedItems: [],
      selectedWarningStatus: 1,
    };
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data();
      },
      deep: true
    },
    storeRole() {
      this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: !(this.storeRole & 2)});
    },
    chinaStores() {
        let header_item = _.find(this.headers, {value: "ChinaStoreID"});
        if(header_item) {
            header_item.values = _.map(this.chinaStores, (item) => {
                return {
                    value: item.ID,
                    name: item.Name
                }
            }) || []
        }
    }
  },
  computed: {
    ...mapState({
      items: state => state.orderTransaction.all.data,
      total_rows: state => state.orderTransaction.all.total,
      currentItem: state => state.orderTransaction.selected,
      loading: state => state.orderTransaction.loading,
      packages: state => state.bigPackage.inTQ,
      chinaStores: (state) => state.commons.chinaStores,
      guarantees: state => {
        let tmp = [{name: 'Không sử dụng', value: 0}];
        if(state.feeGuarantee.all.data) {
        state.feeGuarantee.all.data.forEach(element => {
            tmp.push({name: element.PackageName, value: element.ID});
        });
        }
        return tmp;
      },
    }),
    storeRole() {
      return this.$store.state.authentication.role.StoreCN;
    },
    filter_headers() {
      let tmp = [...this.headers];
      tmp.push({
          text: "Đóng gỗ",
          value: "IsFragileGoods",
          filterable: true,
          values: [{value: 0, name: 'N'}, {value: 1, name: 'Y'}],
          dataType: configs.DATA_TYPE["Enum"]
        });
      tmp.push({
          text: "Kiểm hàng",
          value: "IsCheck",
          filterable: true,
          values: [{value: 0, name: 'N'}, {value: 1, name: 'Y'}],
          dataType: configs.DATA_TYPE["Enum"]
        });
      tmp.push({
          text: "Bảo hiểm",
          value: "OrderGuarantee",
          filterable: true,
          values: this.guarantees,
          dataType: configs.DATA_TYPE["Enum"]
        });
      return tmp;
    },
  },
  methods: {
    filter_data: function() {
      this.selectedItems = [];
      _.remove(this.filterConditions, {
        column: 'IsWarning'
      }); 
      _.remove(this.filterConditions, {
        column: 'Status'
      });
      let pr = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions,
        full_history: this.$store.state.commons.fullHistory ? 1 : 0,
        fields: _.map(this.filter_headers, (h) => {
            return h.value;
        }),
      };
      pr.fields.push('ChinaStoreID');
      if(this.selectedStatus >= 0) {
        pr.filter.push({
          column: "Status",
          value: this.selectedStatus,
          condition: "equal"
        });
      }
      pr.filter.push({
        column: "IsWarning",
        value: 1,
        condition: "equal"
      });
      this.$store.dispatch("bigPackage/getListInTQ");
      this.$store.dispatch("orderTransaction/getList", pr);
      this.$store.dispatch("feeGuarantee/getList");
    },
    gotoDetail: function(id) {
      let item = _.find(this.items, { ID: id });
      this.$store.commit("orderTransaction/setDetail", { data: item });
      this.dialogEditTranCode = true;
    },
    deleteItem: function(id) {
      window.getApp.$emit("REQUEST_DELETE_DATA", id);
    },    
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    get_status_color(val, enums) {
      return this.$options.filters.display_color(val, enums);
    },
    createData(username = "") {
      if(this.storeRole & 2) {
        this.$store.commit("orderTransaction/setDetail", {
          data: {
            ID: 0,
            TransactionCode: "",
            FeeShip: 0
          }
        });
        this.dialogStoreManager = true;
      }
      else {
        sendErrorNotice("Bạn không có quyền thêm mới!");
      }
    },
    saveItem(item) {
      this.$store.dispatch("orderTransaction/setDetail", {
        data: {
          ...item
        },
        id: item.ID
      });
    },
    saveData() {
      this.saveItem(this.currentItem);
      this.dialogEditTranCode = false;
    },
    closePopup() {
      this.dialogStoreManager = false;
      this.filter_data();
    },
    getBigPackage(bigPackageID) {
      const item = _.find(this.packages, {ID: bigPackageID});
      return item ? item.PackageCode : '';
    },
    updateBatch() {
      var ids = _.map(this.selectedItems, 'ID');
      if(ids.length > 0) {
          this.$store.dispatch("orderTransaction/setDetail", {'data': {'TransactionView': 'transaction_list', 'WarningStatus': this.selectedWarningStatus, 'ListID': ids}, 'id': ids[0]});
          this.dialogUpdate = false;
      } 
    }
  },
  mounted() {
    this.$store.dispatch("commons/getAllChinaStores");
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
  }
};
</script>
